import { render } from "./ImageUploadPopUpComponent.vue?vue&type=template&id=51f1cdb6&scoped=true"
import script from "./ImageUploadPopUpComponent.vue?vue&type=script&lang=js"
export * from "./ImageUploadPopUpComponent.vue?vue&type=script&lang=js"

import "./ImageUploadPopUpComponent.vue?vue&type=style&index=0&id=51f1cdb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51f1cdb6"

export default script